import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TrashCanOutline } from 'mdi-material-ui';
import { Typography, Tooltip, CircularProgress, IconButton, Stack, } from '@mui/material';
import CardMediaThumbnail from '../../CardMediaThumbnail';
const UploadListItem = ({ file, onDelete, isLoading = false, }) => {
    const { name, url } = file;
    const handleDelete = () => {
        onDelete();
    };
    return (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-between", width: "100%", overflow: "hidden" }, { children: [_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", width: "50%" }, { children: [_jsx(CardMediaThumbnail, { url: url || '', style: { width: '25px', height: '25px' } }), _jsx(Tooltip, Object.assign({ title: name, arrow: true }, { children: _jsx(Typography, Object.assign({ variant: "h4", width: '80%', whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", ml: 2 }, { children: url ? (_jsx("a", Object.assign({ href: url, target: "_blank", style: { color: '#172B4D', textDecoration: 'none' } }, { children: name }))) : (name) })) }))] })), isLoading ? (_jsx(CircularProgress, { sx: {
                    marginLeft: '5px',
                }, size: 18 })) : (_jsx(IconButton, Object.assign({ onClick: handleDelete }, { children: _jsx(TrashCanOutline, { style: {
                        width: '18px',
                        color: '#FD573A',
                        marginLeft: '2px',
                    } }) })))] })));
};
export default UploadListItem;
